import React, {useState} from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';
import Slide from '@material-ui/core/Slide';
import {Paper, Typography} from '@material-ui/core/';
import {Slider} from '@material-ui/core/';
import {Button} from '@material-ui/core/';

import SetupView from '../WakeLock';

const useStyles = makeStyles((theme) => createStyles({
    sectionTitle: {
      margin: theme.spacing(3, 2),
    },
    paper: {
        width: '20%',
        top: '80px',
        height: 'calc(100% - 80px - 70px)', // 80px is the 60px bottom area + 20px clearance
        padding: theme.shape.borderRadius, // ensures we clear the border radius
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        display: "flex",
        flexDirection: 'column',
        position: 'absolute',
        right: 0,
        backgroundColor: (theme.palette.type==="light") ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.6)',
        maxHeight: '85%',
        overflow: 'auto'
    }
  }));

export const DeveloperSidePanel = (props) => {
    const classes = useStyles();
    const [showCanvasStats, setShowCanvasStats] = useState(false);
    const setupView = () => {
        SetupView();
    }
    const toggleDarkMode = () => {
        console.log("Toggle dark mode");
        const useDark =(localStorage["dark"]==null || localStorage["dark"]==="true");
        if (useDark) {
          localStorage["dark"] = "false";
        } else {
          localStorage["dark"] = "true";
        }
        window.location.reload(true);
    }
    const toggleCanvasStats = () => {
        if (showCanvasStats) {
            setShowCanvasStats(false);
            props.setShowStats(false);
        } else {
            setShowCanvasStats(true);
            props.setShowStats(true);
        }
    }

    const useDark = (localStorage["dark"]==null || localStorage["dark"]==="true");
    return <div>
      <Slide direction="left" in={true}>
        <Paper className={classes.paper}>
          <Typography variant="h6" gutterBottom>Developer panel</Typography>
          Transparency
          <Slider value={props.desiredOpacity} onChange={props.handleOpacityChange}
            aria-labelledby="discrete-slider"
            valueLabelDisplay="auto"
            step={0.05}
            marks
            min={0.0}
            max={1.0}
            style={{ flex: 1, width: "80%" }} />
            <br />
            <Button onClick={setupView}>Setup Window</Button>
            <Button onClick={toggleDarkMode}>Toggle {(useDark) ? "light" : "dark"} mode</Button>
            <Button onClick={toggleCanvasStats}>Show canvas stats</Button>
      </Paper>
    </Slide>
    </div>
}

export default DeveloperSidePanel;